import Cookies from 'js-cookie';

export const getIsLoggedInCookie = () => {
    const cookieValue = Cookies.get('isLoggedIn');

    if (cookieValue === 'True' || cookieValue === 'true') return true;

    return false;
};
